"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Constant = require("../../Constant");

var _ExpandableContent = require("../../../ExpandableContent");

var _ActionIconItem = _interopRequireDefault(require("./ActionIconItem"));

var _Typography = require("../../Typography");

var _minusThick = _interopRequireDefault(require("../../../assets/images/minus-thick.svg"));

var _plusThick = _interopRequireDefault(require("../../../assets/images/plus-thick.svg"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  border-bottom: 1px solid ", ";\n  height: 7.4rem;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Summary = (0, _styledComponents.default)(_ExpandableContent.Summary)(_templateObject(), _Constant.Color.GREY_2);

var ExpandableSummaryContent = function ExpandableSummaryContent(_ref) {
  var isOpen = _ref.isOpen,
      label = _ref.label,
      marketingIcon = _ref.marketingIcon;
  return /*#__PURE__*/_react.default.createElement(Summary, null, /*#__PURE__*/_react.default.createElement(_ExpandableContent.SummaryHeading, {
    as: _Typography.Typography.SidebarHeader,
    padding: "13px 15px"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: marketingIcon,
    alt: "",
    "data-testid": "marketing-icon"
  }), /*#__PURE__*/_react.default.createElement(_ExpandableContent.SummaryText, null, label), /*#__PURE__*/_react.default.createElement(_ActionIconItem.default, {
    actionIcon: isOpen ? _minusThick.default : _plusThick.default
  })));
};

ExpandableSummaryContent.propTypes = {
  /** The `Details` component sets this to true when the content is expanded */
  isOpen: _propTypes.default.bool,

  /** Text that is visible whether content is expanded or collapsed */
  label: _propTypes.default.string.isRequired,

  /** Icon that appears to the left of the `label` text */
  marketingIcon: _propTypes.default.string.isRequired
};
ExpandableSummaryContent.defaultProps = {
  isOpen: false
};
var _default = ExpandableSummaryContent;
exports.default = _default;